import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';

export const PageType = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${grey1};
  border: 1px solid ${grey5};
  border-radius: ${rem(40)};
  gap: ${rem(spacing8)};
  padding: ${rem(spacing8)};
`;
